module.exports = __webpack_public_path__ + "static/media/dk_3N.b348d246.png";